import axios from "axios";
import _ from "lodash";
import Vue from 'vue'
// import store from '../index.js.erb'

function setFormData(achievement) {
    const formatData = new FormData();

     for  (let key in achievement) {
         formatData.append(`achievement[${key}]`, achievement[key]);
     }

    return formatData
}

function isFileUpdated(achievement) {
    const file = achievement?.file?.url
    if (file !== undefined) return 'not_update'
    return 'update'
}

const AchievementFormStore = {
    namespaced: true,
    state: ()=>({
        achievements_list: [],
        id_achievement: null,
        achievement: {
            name: null,
            description: null,
            prtf_achievement_type_id: null,
            prtf_achievement_kind_id: null,
            prtf_achievement_level_id: null,
            prtf_achievement_unit_id: null,
            file: null,
            date_end: null,
        },
        dialog: false,
        edit_mode_form: false,
        errors: {},
        loading: false,
    }),

    getters: {

    },

    mutations: {
        setAchievementData: (state, {key:key, data: data}) => state.achievement[`${key}`] = data,

        setAchievementList:(state, response) => state.achievements_list = response,

        setDialog: (state, flag) => state.dialog = flag,

        resetAchievement: (state) =>   Object.keys(state.achievement).forEach(key => {state.achievement[key] = null}),

        editAchievement(state, achievement) {
            const editAchievement = _.cloneDeep(achievement);
            state.id_achievement = editAchievement.id;
            state.achievement.name = editAchievement.name;
            state.achievement.description = editAchievement.description || "";
            state.achievement.prtf_achievement_type_id = editAchievement.prtf_achievement_type_id;
            state.achievement.prtf_achievement_kind_id = editAchievement.prtf_achievement_kind_id;
            state.achievement.prtf_achievement_level_id = editAchievement?.id_level || null;
            state.achievement.prtf_achievement_unit_id = editAchievement?.id_unit || null;
            state.achievement.file = editAchievement?.file
            state.achievement.date_end = editAchievement.date_end;
            state.edit_mode_form = true;
            state.dialog = true;
        },

        editModeForm: (state, flag) => state.edit_mode_form = flag,

        resetIdAchievement: (state) => state.id_achievement = null,

        setErrors: (state, errors) => state.errors = errors,

        setLoading: (state, flag) => state.loading = flag,
    },

    actions: {
        async getAchievementList({commit}) {
            await axios.get(`/portfolio/achievements/get_achievement_list.json`)
                .then((response) => {
                    commit('setAchievementList', response.data.achievement_list);
                })
                .catch(errors => console.log(errors))
                .finally()
        },

        async createAchievement({state, commit, dispatch}) {
            commit('setLoading', true);
            const formData = setFormData(state.achievement);
            const token = document.querySelector('[name=csrf-token]').content;
            await axios.post(`/portfolio/achievements/create_person_achievement.json`,formData,{headers: { 'Content-Type': 'multipart/form-data'}})
                .then((response) => {
                    commit('achievement/unshiftAchievementInList', response.data.achievement, {root:true});
                    commit('setErrors', {});
                    dispatch('setDialogAction', false);
                })
                .catch(errors => {
                    commit('setErrors', JSON.parse(errors.request.response));
                })
                .finally(()=> commit('setLoading', false))
        },

        async updateAchievement({state, commit, dispatch}) {
            commit('setLoading', true);
            const formData = setFormData(state.achievement);
            const token = document.querySelector('[name=csrf-token]').content;
            await axios.put(
                `/portfolio/achievements/update_person_achievement.json`,
                formData,
                {params: {id:state.id_achievement, updated_file: isFileUpdated(state.achievement)},
                headers: { 'Content-Type': 'multipart/form-data'}})
                .then((response) => {
                        commit('achievement/updatingAchievementInList', {
                        id: state.id_achievement,
                        achievement: response.data.achievement
                    },
                    {root:true});
                    commit('setErrors', {});
                    dispatch('setDialogAction', false);
                })
                .catch(errors => commit('setErrors', JSON.parse(errors.request.response)))
                .finally(()=> commit('setLoading', false))
        },

        async setDialogAction(context, flag) {
            if (!flag) {
                context.commit('resetAchievement');
                context.commit('editModeForm',false);
                context.commit('resetIdAchievement');
            }
            context.commit("setDialog", flag);
        },

    },
}

export default AchievementFormStore